import PropTypes from 'prop-types';
import { Link, MediaQuery } from '@spotahome/ui-library';
import classNames from 'classnames';

import { trans, getPagePath, getResourcePath } from '@spotahome/soyuz/client';

import { TOP_CITIES } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';

// styles
import './City.scss';

const City = ({ id, countryPageUrl = null, countryId }) => {
  const cityName = trans(`city.${id}`);

  const path = getPagePath('marketplace.free-search', {
    params: { locationString: id }
  });

  const { isSmallerThanLaptop } = MediaQuery;

  const cityImageClassnames = classNames('city__image', {
    'city__image--small-display': isSmallerThanLaptop()
  });

  const countryName = trans(`country.${countryId}`);

  return (
    <div className={`city ga-home-city-list-${id}`}>
      <a href={path}>
        <LazyLoad
          height={310}
          offset={150}
          once
          className={cityImageClassnames}
          as="figure"
        >
          <img
            src={getResourcePath(`/images/home/city-list-redesign/${id}.jpg`)}
            alt={cityName}
            height={310}
          />
        </LazyLoad>

        <div className="city__count">
          <h3 className="city__name">{cityName}</h3>
          <span className="city__homes">
            +{`${TOP_CITIES[id]} ${trans('landingpage.label.properties')}`}
          </span>
        </div>
      </a>

      {countryPageUrl && (
        <Link href={countryPageUrl} className="city__country-link">
          {trans('landingpage.more.on.country', { countryName })}
        </Link>
      )}
    </div>
  );
};

City.propTypes = {
  id: PropTypes.string.isRequired,
  countryId: PropTypes.string.isRequired,
  countryPageUrl: PropTypes.string
};
export default City;
